// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"CreateUserModal_btn-primary__5zg-u","button":"CreateUserModal_button__3YW6g","form-input":"CreateUserModal_form-input__1h1Qp","input":"CreateUserModal_input__2CnTn"};